import { SHOW_MESSAGE, HIDE_MESSAGE } from '../actions/action-types';

const initialState = {
  content: '',
  visibleMessage: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SHOW_MESSAGE:
      return {
        ...state,
        visibleMessage: true,
        content: payload.content,
      };

    case HIDE_MESSAGE:
      return {
        ...state,
        visibleMessage: false,
        content: '',
      };

    default:
      return state;
  }
};
